import React from 'react';
import Spinner from '../spinner';
import css from './screen-fetching.module.css';

function Fetching() {
  return (
    <div className={css.spinnerWrapper}>
      <Spinner size={40} strokeWidth={3} />
    </div>
  );
}

export default Fetching;
